function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.385 9.913h1.364l3.889-3.888.19-1.651a17.477 17.477 0 00-28.432 8.527 2.114 2.114 0 011.364-.082l7.777-1.282s.395-.655.6-.614a9.7 9.7 0 0113.275-1.01h-.027z",
  fill: "#EA4335"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.177 12.901a17.518 17.518 0 00-5.28-8.513l-5.458 5.457A9.7 9.7 0 0132 17.54v.969a4.857 4.857 0 010 9.714h-9.714l-.969.982v5.826l.97.969H32A12.634 12.634 0 0039.177 12.9z",
  fill: "#4285F4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.558 35.945h9.715v-7.777h-9.715c-.692 0-1.376-.149-2.005-.436l-1.365.423-3.915 3.888-.341 1.364a12.565 12.565 0 007.626 2.538z",
  fill: "#34A853"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.558 10.718a12.633 12.633 0 00-7.626 22.648l5.634-5.634a4.858 4.858 0 116.426-6.426l5.635-5.635a12.621 12.621 0 00-10.069-4.953z",
  fill: "#FBBC05"
});

function SvgGcp(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

export default SvgGcp;